import { IMessage, IVisibleTo } from "@home-health-notify/domain";
import MessageDetail from "./MessageDetail";
import { IChatInfoAccess } from "hhn-commons";

interface MessageInfoProps {
  message: IMessage;
  recipients: IVisibleTo[];
  isLoading: boolean;
  chatInfoAccess: IChatInfoAccess;
}

const MessageInfo = ({
  message,
  recipients,
  isLoading,
  chatInfoAccess,
}: MessageInfoProps) => {
  return (
    <MessageDetail
      message={message}
      recipients={recipients}
      isLoading={isLoading}
      showSearch
      enableAcknowledgement={false}
      chatInfoAccess={chatInfoAccess}
    />
  );
};

export default MessageInfo;
